import { render, staticRenderFns } from "./ProjectPagePricing.vue?vue&type=template&id=1223a7cc&scoped=true"
import script from "./ProjectPagePricing.vue?vue&type=script&lang=js"
export * from "./ProjectPagePricing.vue?vue&type=script&lang=js"
import style0 from "./ProjectPagePricing.vue?vue&type=style&index=0&id=1223a7cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1223a7cc",
  null
  
)

export default component.exports